import {
	OPEN_DIALOG_MODIFIED_EMAILS,
	CLOSE_DIALOG_MODIFIED_EMAILS,
	SET_SEARCH,
	ON_EXPAND_TABLE,
	RESET_EXPANDED_ITEM
} from "./FrequencyTrendLimitLogActionTypes";
import {
	GET,
	SET,
	RESET_STATE
} from "@/stores/CommumActionTypes";
import FrequencyTrendLimitLogFactory from "../../factories/FrequencyTrendLimitLogFactory";

const mutations = {
	[OPEN_DIALOG_MODIFIED_EMAILS]: (state, tableRow) =>
	{
		state.showDialog = true;
		state.itemOnEmailClick = tableRow;
	},
	[CLOSE_DIALOG_MODIFIED_EMAILS]: (state) =>
	{
		state.showDialog = false;
		state.itemOnEmailClick = {};
	},
	[GET]: (state) =>
	{
		state.logs = [];
		state.isLoadingTableData = true;
	},
	[SET]: (state, logs) =>
	{
		state.logs = logs;
		state.isLoadingTableData = false;
	},
	[SET_SEARCH]: (state, strSearch) =>
	{
		state.search = strSearch;
	},
	[ON_EXPAND_TABLE]: (state, event) =>
	{
		state.itemOnExpandedPanel = event.value ? [ event.item ] : [];
	},
	[RESET_STATE]: (state) =>
	{
		Object.assign(state, FrequencyTrendLimitLogFactory.StateEmpty());
	},
	[RESET_EXPANDED_ITEM]: (state) =>
	{
		state.itemOnExpandedPanel = [];
	},
};

export default { mutations };